module.exports = __webpack_public_path__ + "img/类型.85911241.svg";